import * as React from "react";
import {AccountPageWrapper} from "components/account/widgets/AccountPageWrapper";
import {AccountContentContainer} from "components/account/widgets/AccountContentContainer";
import {IAccountPage, AccountPages} from "components/account/Account";
import DashboardData from "data/DashboardData";
import {SolutionCard} from "components/dashboard/SolutionCard";
import {AccountNavCard} from "components/account/widgets/AccountNavCard";
import {CircleContainer} from "components/widgets/icons/CircleContainer";
import {ParticipationSettingsIcon} from "components/widgets/icons/ParticipationSettingsIcon";
import {DateTimeHelpers} from "shared/DateTimeHelpers";
import {DateTime} from "luxon";
import {DashboardSolution} from "data/entities/DashboardSolution";
import {TrashIcon} from "components/widgets/icons/TrashIcon";
import './AccountParticipationSettings.pcss';

interface Props {
  onChangeAccountPage:(page:IAccountPage) => void;
  onRemoveDashboardSolution:(solution:DashboardSolution) => void;
}

export function AccountParticipationSettings(props: Props): JSX.Element {

  const participatingSolutions = DashboardData.active.filter(s=>s.registered && (s.type === 'challenge' || s.type === 'health fair' ));

  return (
    <AccountPageWrapper
      title={"Participation Settings"}
      subTitle={""}
      backOrCloseAction={() => {
        props.onChangeAccountPage(AccountPages.Overview);
      }}
      backOrCloseLabel={"Back to Account Overview"}
    >
      <section>
        {DashboardData.removedDashboardSolutionName &&
          <>
            <AccountContentContainer color={"#fff"} hideSupport>
              <div className={"participation-removed"}>
                <div className={"pr-icon"}><TrashIcon /></div>
                <div className={"pr-message"}>
                  <h2>Participation removed for {DashboardData.removedDashboardSolutionName}</h2>
                  <p>You will no longer receive emails for this program. You can re-register if you change your mind.</p>
                </div>
              </div>
            </AccountContentContainer>
            <div style={{height:'30px'}} />
          </>
        }


      <AccountContentContainer>
        <div>
          <p className={"important"}>You may remove your registration and participation for certain programs that include ongoing communications and engagement (e.g. Challenges, Virtual Health Fairs).</p>
          <p>
            If you remove participation:
          </p>
          <ul>
            <li>you will no longer receive emails for this program</li>
            <li>your Zoom webinar participation will be canceled</li>
            <li>your points for the program will be removed and any badge you may have earned</li>
            <li>your participation will be removed from reporting</li>
          </ul>
        </div>


        {participatingSolutions.length === 0 ?
          <AccountNavCard
            title={""}
            subTitle={"No active registrations."}
          />
          :
          <>
            {participatingSolutions.map(dashboardSolution => {
                const registrationDate = DateTimeHelpers.parseDateTime(dashboardSolution.registrationDate);
                const subTitle = null!= registrationDate ? "Registered "+DateTimeHelpers.monthDayOrdinal(registrationDate) : "";
                return (
                  <AccountNavCard
                    key={dashboardSolution._id}
                    title={dashboardSolution.name}
                    subTitle={subTitle}
                    buttonLabel={"Remove Participation"}
                    buttonAction={()=>{
                      props.onRemoveDashboardSolution(dashboardSolution);
                    }}
                    buttonVariant={"outlined"}
                    buttonHideArrow={true}
                  />
                );
              }
            )}
          </>
        }



      </AccountContentContainer>
      </section>
    </AccountPageWrapper>
  );
}

